import { render, staticRenderFns } from "./PassageFilters.vue?vue&type=template&id=557fbd0a&scoped=true&"
import script from "./PassageFilters.vue?vue&type=script&lang=ts&"
export * from "./PassageFilters.vue?vue&type=script&lang=ts&"
import style0 from "./PassageFilters.vue?vue&type=style&index=0&id=557fbd0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557fbd0a",
  null
  
)

export default component.exports